.mapPicker {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.mapSearch {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  z-index: 700;
}

.mapSearchResults {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  box-shadow: 0 8px 24px rgb(15 23 42 / 12%);
  display: flex;
  flex-direction: column;
  left: 0;
  max-height: 220px;
  overflow: auto;
  padding: 6px;
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 9999;
}

.mapSearchResult {
  background: transparent;
  border: 0;
  border-radius: 4px;
  color: var(--color-foreground);
  cursor: pointer;
  font: inherit;
  padding: 8px;
  text-align: left;
}

.mapSearchResult:hover {
  background: var(--color-secondary);
}

.mapCanvas {
  border: 1px solid var(--color-border);
  border-radius: 6px;
  height: 320px;
  overflow: hidden;
  position: relative;
}

.leafletMap {
  height: 100%;
  width: 100%;
}

.mapCenterMarker {
  border: 2px solid var(--color-primary);
  border-radius: 999px;
  box-shadow:
    0 0 0 4px rgb(31 111 235 / 18%),
    0 2px 8px rgb(15 23 42 / 22%);
  height: 18px;
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 18px;
  z-index: 500;
}

.mapCenterMarker::after {
  background: var(--color-primary);
  border-radius: 999px;
  content: '';
  height: 6px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
}

.mapActions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}
